export default __webpack_public_path__ + "static/media/feature-image2.593f336e.png";